'use client';

import { useTranslations } from 'next-intl';
import styles from './CartEmptyState.module.css';

interface CartEmptyStateProps {
  onBackToBrowse: () => void;
  className?: string;
}

export const CartEmptyState = ({ onBackToBrowse }: CartEmptyStateProps) => {
  const t = useTranslations('cart');
  return (
    <div className={styles.root}>
      <div className={styles.centered}>
        {/* Not a heading: the cart drawer is in the DOM on every page, so a
            heading element here put this copy into every heading outline. */}
        <p className={styles.emptyTitle}>{t('sharedCart.cartUi.emptyTitle')}</p>
        <p style={{ textAlign: 'center' }}>
          {t('sharedCart.cartUi.emptyDescription')}
        </p>
        <button className={`${styles.blueButton} blue-button`} onClick={onBackToBrowse}>
          {t('sharedCart.cartUi.backToBrowse')}
        </button>
      </div>
    </div>
  );
};
